import React, { useState, useEffect } from 'react'

export const RoutesContext = React.createContext({})

export const useRoutes = () => React.useContext(RoutesContext)

export const RoutesContextProvider = ({ children }) => { 
  const [routes, setRoutes] = useState([
    // {
    //   name: 'Name',
    //   title: 'TITLE',
    //   path: '',
    //   icon: 'user-edit',
    //   disabled: false,
    // }
  ])

  return (
    <RoutesContext.Provider value={{ routes, setRoutes }}>
      { children }
    </RoutesContext.Provider>
  )
}

export default useRoutes
